/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Label
 */
export interface Label {
  /**
   *
   * @type {string}
   * @memberof Label
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  organizationId?: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof Label
   */
  color?: string
  /**
   *
   * @type {number}
   * @memberof Label
   */
  sort?: number
  /**
   *
   * @type {boolean}
   * @memberof Label
   */
  isSystem?: boolean
  /**
   *
   * @type {number}
   * @memberof Label
   */
  documentsCount?: number
  /**
   *
   * @type {Date}
   * @memberof Label
   */
  createdAt?: Date
  /**
   *
   * @type {Date}
   * @memberof Label
   */
  updatedAt?: Date
}

export function LabelFromJSON(json: any): Label {
  return LabelFromJSONTyped(json, false)
}

export function LabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Label {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    organizationId: !exists(json, 'organization_id') ? undefined : json['organization_id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    color: !exists(json, 'color') ? undefined : json['color'],
    sort: !exists(json, 'sort') ? undefined : json['sort'],
    isSystem: !exists(json, 'is_system') ? undefined : json['is_system'],
    documentsCount: !exists(json, 'documents_count') ? undefined : json['documents_count'],
    createdAt: !exists(json, 'created_at') ? undefined : new Date(json['created_at']),
    updatedAt: !exists(json, 'updated_at') ? undefined : new Date(json['updated_at'])
  }
}

export function LabelToJSON(value?: Label | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    organization_id: value.organizationId,
    name: value.name,
    color: value.color,
    sort: value.sort,
    is_system: value.isSystem,
    documents_count: value.documentsCount,
    created_at: value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
    updated_at: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString()
  }
}
